import { PaymentMethodCancelUI } from 'libs/types/app/src/lib/paymentMethod.types';
import { Control, Controller, useFormState } from 'react-hook-form';
import { MBox, MFormField, MText } from '../../../components/Monetize';
import { MTextAreaCharacterLimited } from '../../../components/Monetize/MTextAreaCharacterLimited';

interface PaymentMethodCancelFormProps {
  control: Control<PaymentMethodCancelUI>;
}

export const PaymentMethodCancelForm = ({
  control,
}: PaymentMethodCancelFormProps) => {
  const { errors } = useFormState({ control });

  return (
    <MBox>
      <MText color="tGray.darkPurple" fontSize="sm" mb={4}>
        Once the payment method is cancelled, it will no longer be available for
        future transactions.
      </MText>
      <MText color="tRed.base" fontSize="sm" mb={4}>
        This action is irreversible.
      </MText>

      <MFormField error={errors?.cancellationReason} mb="2">
        <Controller
          name="cancellationReason"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <MTextAreaCharacterLimited
              field={field}
              maxLength={255}
              placeholder={'Provide a reason for canceling this payment method'}
            ></MTextAreaCharacterLimited>
          )}
        />
      </MFormField>
    </MBox>
  );
};
